import { render } from "./vip.vue?vue&type=template&id=1142c811&scoped=true"
import script from "./vip.vue?vue&type=script&lang=js"
export * from "./vip.vue?vue&type=script&lang=js"

import "./vip.vue?vue&type=style&index=0&id=1142c811&lang=stylus&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1142c811"]])

export default __exports__